import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "icon-check" }, null, -1)

import { onMounted, Ref, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ui-checkbox',
  props: {
	modelValue: { type: Boolean, value: false },
	disabled: { type: Boolean, value: false },
},
  emits: ["update:modelValue", "clicked"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props;

const innerChecked: Ref<boolean> = ref(false);
watch(
	() => props.modelValue,
	(value) => {
		innerChecked.value = value;
	}
);
watch(
	() => innerChecked.value,
	(value) => {
		emits("update:modelValue", value);
	}
);

onMounted(() => {
	innerChecked.value = props.modelValue;
});

function onClick() {
	if (props.disabled) {
		return;
	}
	innerChecked.value = !innerChecked.value;
	emits("clicked");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-checkbox", { disabled: __props.disabled, checked: innerChecked.value }]),
    onClick: onClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      (innerChecked.value)
        ? _renderSlot(_ctx.$slots, "checked", { key: 0 }, () => [
            _hoisted_2
          ])
        : _renderSlot(_ctx.$slots, "unchecked", { key: 1 })
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})